query marketDataExport {
    marketDataExport
}
